import React, { useState } from 'react';

import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';
import { CustomeTextField } from '../../../generic/CustomeTextField';
import { EditAdministrativeUnitCourtAsign } from './EditAdministrativeUnitCourtAsign';
import { ICourt } from '../../../Interfaces/ICourt';
import {
  adminstrativeUnitFullObjectSchema,
  IAdminstrativeUnit,
  IAdminstrativeUnitFullObject,
} from '../../../Interfaces/IAdminstrativeUnit';
import { ICourtRole } from '../../../Interfaces/ICourtRole';
import { ICourtAdminstrativeUnitAssignment } from '../../../Interfaces/ICourtAdminstrativeUnitAssignment';
import { useAlert } from '../../../context/AlertContext';
import { useUpdateAdministrativeUnitFullObject } from '../../../hooks/reactQuerys/AdminstrativeUnitQueries';

interface IProps {
  currentCourt?: ICourt;
  currentAdminUnit: IAdminstrativeUnit;
  courtRoles: ICourtRole[];
  courtAdminUnitAssignments: ICourtAdminstrativeUnitAssignment[];
  //
  onSuccess: Function;
}

export const EditAdministrativeUnit: React.FC<IProps> = ({
  currentCourt,
  currentAdminUnit,
  courtRoles,
  courtAdminUnitAssignments,
  onSuccess,
}) => {
  const { showAlert } = useAlert();
  const {
    updateAdministrativeUnitFullObject,
    isPendingUpdateAdministrativeUnitFullObject,
  } = useUpdateAdministrativeUnitFullObject();
  const isPending = isPendingUpdateAdministrativeUnitFullObject;

  const [editAdminUnit, setEditAdminUnit] = useState(currentAdminUnit);
  const [editCourtAdminUnitRoles, setEditCourtAdminUnitRoles] = useState(
    courtAdminUnitAssignments.filter(
      courtRole =>
        courtRole.idAdministrativeUnit === currentAdminUnit.idAdministrativeUnit
    )
  );

  //
  const otherCourtRoles = Array.from(
    new Set(
      courtAdminUnitAssignments
        .filter(
          courtRole =>
            courtRole.idAdministrativeUnit ===
            currentAdminUnit.idAdministrativeUnit
        )
        .filter(courtRoles => courtRoles.idCourt !== currentCourt?.idCourt)

        .map(courtRoles => courtRoles.idCourt)
    )
  );

  const handleReset = () => {
    setEditAdminUnit(currentAdminUnit);
    setEditCourtAdminUnitRoles(
      courtAdminUnitAssignments.filter(
        courtRole =>
          courtRole.idAdministrativeUnit ===
          currentAdminUnit.idAdministrativeUnit
      )
    );
  };

  const onUpdate = async () => {
    try {
      const uploadObject: IAdminstrativeUnitFullObject = {
        ...editAdminUnit,
        Assignments: editCourtAdminUnitRoles,
      };
      const updatedObject = await updateAdministrativeUnitFullObject(
        adminstrativeUnitFullObjectSchema.parse(uploadObject)
      );
      setEditAdminUnit(updatedObject);
      onSuccess();
      //refetchCourts();
      showAlert({
        text: 'Erfolgreich gespeichert!',
        severity: 'success',
      });
    } catch (error) {
      console.error(error);
      showAlert({
        text: 'Es ist ein Fehler aufgetreten!',
        severity: 'error',
      });
    }
  };

  return (
    <>
      <Typography variant='h6'>Gemarkung</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CustomeTextField
            attr='AdministrativeUnit'
            label='Gemarkung'
            object={editAdminUnit}
            setObject={setEditAdminUnit}
            type='string'
            required
          />
        </Grid>
      </Grid>

      <Box>
        {currentCourt && (
          <>
            <EditAdministrativeUnitCourtAsign
              court={currentCourt}
              adminUnit={currentAdminUnit}
              courtRoles={courtRoles}
              editCourtAdminUnitRoles={editCourtAdminUnitRoles}
              setEditCourtAdminUnitRoles={setEditCourtAdminUnitRoles}
            />

            <Box sx={{ mt: 3 }}>
              <Typography>
                Dieser Gemarkung sind weitere <b>{otherCourtRoles.length}</b>{' '}
                Gerichte zugeordnet.
              </Typography>
            </Box>
          </>
        )}
      </Box>
      <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
        <Button variant='outlined' onClick={handleReset} disabled={isPending}>
          Zurücksetzen
        </Button>
        <Button variant='contained' disabled={isPending} onClick={onUpdate}>
          {isPending ? (
            <Box display='flex' alignItems='center' gap={1}>
              <span>Speichern</span>
              <CircularProgress size={20} />
            </Box>
          ) : (
            'Speichern'
          )}
        </Button>
      </Box>
    </>
  );
};
